import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bcc73352")

_pushScopeId("data-v-bcc73352")
const _hoisted_1 = { class: "kn-overflow-y" }
const _hoisted_2 = { class: "p-fluid p-m-5" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "dialectName",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "descr",
  class: "kn-material-input-label"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "schemaAttribute",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "kn-material-input-label" }
const _hoisted_15 = { class: "p-field-radiobutton" }
const _hoisted_16 = { for: "readOnly" }
const _hoisted_17 = { class: "p-field-radiobutton" }
const _hoisted_18 = { for: "readAndWrite" }
const _hoisted_19 = {
  key: 1,
  class: "p-field-checkbox"
}
const _hoisted_20 = { for: "useForDataprep" }
const _hoisted_21 = { class: "kn-material-input-label" }
const _hoisted_22 = { class: "p-field-radiobutton" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "JDBC" }, "JDBC", -1)
const _hoisted_24 = { class: "p-field-radiobutton" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "JNDI" }, "JNDI", -1)
const _hoisted_26 = { class: "p-float-label" }
const _hoisted_27 = {
  for: "jndi",
  class: "kn-material-input-label"
}
const _hoisted_28 = { id: "jndi-help" }
const _hoisted_29 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_30 = { class: "p-float-label" }
const _hoisted_31 = {
  for: "user",
  class: "kn-material-input-label"
}
const _hoisted_32 = { class: "p-float-label" }
const _hoisted_33 = {
  for: "pwd",
  class: "kn-material-input-label"
}
const _hoisted_34 = { class: "p-float-label" }
const _hoisted_35 = {
  for: "urlConnection",
  class: "kn-material-input-label"
}
const _hoisted_36 = { class: "p-float-label" }
const _hoisted_37 = {
  for: "driver",
  class: "kn-material-input-label"
}
const _hoisted_38 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Card = _resolveComponent("Card")
  const _component_DataSourceAdvancedOptions = _resolveComponent("DataSourceAdvancedOptions")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.datasource.label), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain p-jc-center",
          disabled: _ctx.readOnly,
          onClick: _ctx.testDataSource
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.test')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.readOnly || _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.showOwnerMessage)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            severity: "info"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.ownerMessage), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Card, {
        style: _ctx.dataSourceDescriptor.card.style
      }, {
        content: _withId(() => [
          _createVNode("form", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", {
                class: "p-field p-col-12 p-md-6",
                style: _ctx.dataSourceDescriptor.pField.style
              }, [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.datasource.label.$invalid && _ctx.v$.datasource.label.$dirty
                                    }],
                    type: "text",
                    maxLength: "100",
                    modelValue: _ctx.v$.datasource.label.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.datasource.label.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.datasource.label.$touch())),
                    onInput: _ctx.onFieldChange,
                    disabled: _ctx.readOnly || _ctx.disableLabelField
                  }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.datasource.label,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ], 4),
              _createVNode("div", {
                class: "p-field p-col-12 p-md-6",
                style: _ctx.dataSourceDescriptor.pField.style
              }, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_Dropdown, {
                    id: "dialectName",
                    class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.datasource.dialectName.$invalid && _ctx.v$.datasource.dialectName.$dirty
                                    }],
                    options: _ctx.availableDatabases,
                    optionLabel: "databaseDialect.name",
                    optionValue: "databaseDialect.value",
                    modelValue: _ctx.v$.datasource.dialectName.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.datasource.dialectName.$model = $event)),
                    onBeforeShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.datasource.dialectName.$touch())),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectDatabase($event.value))),
                    disabled: _ctx.readOnly
                  }, null, 8, ["options", "modelValue", "class", "disabled"]),
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.dialect')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.datasource.dialectName,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.dialect') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ], 4)
            ]),
            _createVNode("div", {
              class: "p-field",
              style: _ctx.dataSourceDescriptor.pField.style
            }, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_InputText, {
                  id: "descr",
                  class: "kn-material-input",
                  type: "text",
                  maxLength: "160",
                  modelValue: _ctx.datasource.descr,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.datasource.descr = $event)),
                  modelModifiers: { trim: true },
                  onInput: _ctx.onFieldChange,
                  disabled: _ctx.readOnly
                }, null, 8, ["modelValue", "onInput", "disabled"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.description')), 1)
              ])
            ], 4),
            (_ctx.isVisible())
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (_ctx.jdbcOrJndi.type == 'JNDI')
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("div", {
                          class: "p-field",
                          style: _ctx.dataSourceDescriptor.pField.style
                        }, [
                          _createVNode("span", _hoisted_11, [
                            _createVNode(_component_Checkbox, {
                              id: "multiSchema",
                              modelValue: _ctx.datasource.multiSchema,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.datasource.multiSchema = $event)),
                              binary: true,
                              disabled: _ctx.readOnly
                            }, null, 8, ["modelValue", "disabled"]),
                            _createVNode("label", {
                              for: "multiSchema",
                              class: "kn-material-input-label",
                              style: _ctx.dataSourceDescriptor.checkboxLabel.style
                            }, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.multischema')), 5)
                          ])
                        ], 4),
                        (_ctx.datasource.multiSchema)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: "p-field",
                              style: _ctx.dataSourceDescriptor.pField.style
                            }, [
                              _createVNode("span", _hoisted_12, [
                                _createVNode(_component_InputText, {
                                  id: "schemaAttribute",
                                  class: ["kn-material-input", {
                                            'p-invalid': _ctx.v$.datasource.schemaAttribute.$invalid && _ctx.v$.datasource.schemaAttribute.$dirty
                                        }],
                                  type: "text",
                                  maxLength: "45",
                                  modelValue: _ctx.v$.datasource.schemaAttribute.$model,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.datasource.schemaAttribute.$model = $event)),
                                  modelModifiers: { trim: true },
                                  onInput: _ctx.onFieldChange,
                                  disabled: _ctx.readOnly
                                }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.schemaAttribute')), 1)
                              ]),
                              _createVNode(_component_KnValidationMessages, {
                                vComp: _ctx.v$.datasource.schemaAttribute,
                                additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.schemaAttribute') }
                              }, null, 8, ["vComp", "additionalTranslateParams"])
                            ], 4))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.readOnly')), 1),
                  _createVNode("div", {
                    class: "p-field p-formgroup-inline p-mb-3 p-mt-2",
                    style: _ctx.dataSourceDescriptor.pField.style
                  }, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_RadioButton, {
                        id: "readOnly",
                        value: true,
                        modelValue: _ctx.datasource.readOnly,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.datasource.readOnly = $event)),
                        disabled: _ctx.datasource.writeDefault || _ctx.readOnly || _ctx.datasource.useForDataprep
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.readOnly')), 1)
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_RadioButton, {
                        id: "readAndWrite",
                        value: false,
                        modelValue: _ctx.datasource.readOnly,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.datasource.readOnly = $event)),
                        disabled: _ctx.readOnly || !_ctx.selectedDatabase.cacheSupported
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.readAndWrite')), 1)
                    ]),
                    (_ctx.currentUser.isSuperadmin)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "p-field-checkbox",
                          style: _ctx.dataSourceDescriptor.pField.style
                        }, [
                          _createVNode(_component_Checkbox, {
                            id: "writeDefault",
                            modelValue: _ctx.datasource.writeDefault,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.datasource.writeDefault = $event)),
                            binary: true,
                            disabled: _ctx.readOnly || !_ctx.selectedDatabase.cacheSupported || _ctx.datasource.readOnly || !_ctx.currentUser.isSuperadmin
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode("label", {
                            for: "writeDefault",
                            style: _ctx.dataSourceDescriptor.checkboxLabel.style
                          }, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.writeDefault')), 5)
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.currentUser.isSuperadmin)
                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                          _createVNode(_component_Checkbox, {
                            id: "useForDataprep",
                            modelValue: _ctx.datasource.useForDataprep,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.datasource.useForDataprep = $event)),
                            binary: true,
                            disabled: _ctx.readOnly || !_ctx.selectedDatabase.cacheSupported || _ctx.datasource.readOnly || !_ctx.currentUser.isSuperadmin
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.useForDataprep')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('common.type')), 1),
                  _createVNode("div", {
                    class: "p-field p-formgroup-inline p-mt-2",
                    style: _ctx.dataSourceDescriptor.pField.style
                  }, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode(_component_RadioButton, {
                        id: "JDBC",
                        value: 'JDBC',
                        modelValue: _ctx.jdbcOrJndi.type,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.jdbcOrJndi.type = $event)),
                        onChange: _ctx.clearType,
                        disabled: _ctx.readOnly
                      }, null, 8, ["modelValue", "onChange", "disabled"]),
                      _hoisted_23
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_RadioButton, {
                        id: "readAndWrite",
                        value: 'JNDI',
                        modelValue: _ctx.jdbcOrJndi.type,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.jdbcOrJndi.type = $event)),
                        onChange: _ctx.clearType,
                        disabled: _ctx.readOnly || !_ctx.currentUser.isSuperadmin
                      }, null, 8, ["modelValue", "onChange", "disabled"]),
                      _hoisted_25
                    ])
                  ], 4),
                  (_ctx.jdbcOrJndi.type == 'JNDI')
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: "p-field",
                        style: _ctx.dataSourceDescriptor.pField.style
                      }, [
                        _createVNode("span", _hoisted_26, [
                          _createVNode(_component_InputText, {
                            id: "jndi",
                            class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.datasource.jndi.$invalid && _ctx.v$.datasource.jndi.$dirty
                                    }],
                            type: "text",
                            maxLength: "160",
                            modelValue: _ctx.v$.datasource.jndi.$model,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.datasource.jndi.$model = $event)),
                            modelModifiers: { trim: true },
                            onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.datasource.jndi.$touch())),
                            onInput: _ctx.onFieldChange,
                            disabled: _ctx.readOnly
                          }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                          _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.jndi')) + " * ", 1),
                          _createVNode("small", _hoisted_28, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.jndiInfo')), 1)
                        ]),
                        _createVNode(_component_KnValidationMessages, {
                          vComp: _ctx.v$.datasource.jndi,
                          additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.jndi') }
                        }, null, 8, ["vComp", "additionalTranslateParams"])
                      ], 4))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_29, [
                    (_ctx.jdbcOrJndi.type == 'JDBC')
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "p-field p-col-12 p-md-6",
                          style: _ctx.dataSourceDescriptor.pField.style
                        }, [
                          _createVNode("span", _hoisted_30, [
                            _createVNode(_component_InputText, {
                              id: "user",
                              class: "kn-material-input",
                              type: "text",
                              maxLength: "50",
                              modelValue: _ctx.datasource.user,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.datasource.user = $event)),
                              modelModifiers: { trim: true },
                              onInput: _ctx.onFieldChange,
                              disabled: _ctx.readOnly
                            }, null, 8, ["modelValue", "onInput", "disabled"]),
                            _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.user')), 1)
                          ])
                        ], 4))
                      : _createCommentVNode("", true),
                    (_ctx.jdbcOrJndi.type == 'JDBC')
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: "p-field p-col-12 p-md-6",
                          style: _ctx.dataSourceDescriptor.pField.style
                        }, [
                          _createVNode("span", _hoisted_32, [
                            _createVNode(_component_InputText, {
                              id: "pwd",
                              class: "kn-material-input",
                              type: "password",
                              maxLength: "50",
                              modelValue: _ctx.datasource.pwd,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.datasource.pwd = $event)),
                              modelModifiers: { trim: true },
                              onInput: _ctx.onFieldChange,
                              disabled: _ctx.readOnly
                            }, null, 8, ["modelValue", "onInput", "disabled"]),
                            _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.pwd')), 1)
                          ])
                        ], 4))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.jdbcOrJndi.type == 'JDBC')
                    ? (_openBlock(), _createBlock("div", {
                        key: 2,
                        class: "p-field",
                        style: _ctx.dataSourceDescriptor.pField.style
                      }, [
                        _createVNode("span", _hoisted_34, [
                          _createVNode(_component_InputText, {
                            id: "urlConnection",
                            class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.datasource.urlConnection.$invalid && _ctx.v$.datasource.urlConnection.$dirty
                                    }],
                            type: "text",
                            maxLength: "500",
                            modelValue: _ctx.v$.datasource.urlConnection.$model,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.v$.datasource.urlConnection.$model = $event)),
                            modelModifiers: { trim: true },
                            onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.datasource.urlConnection.$touch())),
                            onInput: _ctx.onFieldChange,
                            disabled: _ctx.readOnly
                          }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                          _createVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.urlConnection')) + " * ", 1)
                        ]),
                        _createVNode(_component_KnValidationMessages, {
                          vComp: _ctx.v$.datasource.urlConnection,
                          additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.urlConnection') }
                        }, null, 8, ["vComp", "additionalTranslateParams"])
                      ], 4))
                    : _createCommentVNode("", true),
                  (_ctx.jdbcOrJndi.type == 'JDBC')
                    ? (_openBlock(), _createBlock("div", {
                        key: 3,
                        class: "p-field",
                        style: _ctx.dataSourceDescriptor.pField.style
                      }, [
                        _createVNode("span", _hoisted_36, [
                          _createVNode(_component_InputText, {
                            id: "driver",
                            class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.datasource.driver.$invalid && _ctx.v$.datasource.driver.$dirty
                                    }],
                            type: "text",
                            maxLength: "50",
                            modelValue: _ctx.v$.datasource.driver.$model,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.datasource.driver.$model = $event)),
                            modelModifiers: { trim: true },
                            onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.datasource.driver.$touch())),
                            onInput: _ctx.onFieldChange,
                            disabled: _ctx.readOnly
                          }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                          _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('managers.dataSourceManagement.form.driver')) + " * ", 1)
                        ]),
                        _createVNode(_component_KnValidationMessages, {
                          vComp: _ctx.v$.datasource.driver,
                          additionalTranslateParams: { fieldName: _ctx.$t('managers.dataSourceManagement.form.driver') }
                        }, null, 8, ["vComp", "additionalTranslateParams"])
                      ], 4))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.isVisible())
        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            (_ctx.jdbcOrJndi.type == 'JDBC')
              ? (_openBlock(), _createBlock("div", _hoisted_38, [
                  _createVNode(_component_DataSourceAdvancedOptions, {
                    advancedOptions: _ctx.jdbcPoolConfiguration,
                    isReadOnly: _ctx.readOnly,
                    onFieldChanged: _ctx.onAdvancedOptionsChange
                  }, null, 8, ["advancedOptions", "isReadOnly", "onFieldChanged"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
})